import {
  SelectedFeedsType,
  FeedNameType,
  FeedParamsType,
  VendorFeedSpecs,
} from 'new/components/flows/types/elt/CreateELTFlow/types';
import { createVendorFeedSpecsWrapper } from './utils/vendorFeedSpecsUtils';

export const getDataFeedParams = (
  selectedFeeds: SelectedFeedsType,
  feedName: FeedNameType,
  vendorFeedSpecs: VendorFeedSpecs,
  templateVersion?: 'v1' | 'v2',
): FeedParamsType => {
  //Combine user selections with vendor feed specs to get the feed param setting that will be sent to the backend
  const thisFeedSpecs = vendorFeedSpecs.data_feed_options[feedName];
  const currentFeedSettings = selectedFeeds?.[feedName];

  // Create wrapper for unified v1/v2 handling
  const vendorFeedSpecsWrapper = createVendorFeedSpecsWrapper(
    vendorFeedSpecs,
    templateVersion || 'v1',
  );

  // if currentFeedSettings is defined and feed_selected is true, then the spec should have details about the feed options.
  let dataFeedParams = {
    ref_spec_name: '',
    primary_keys: '',
    ref_spec_resource_name: '',
    ref_field_list_selector: '',
    ref_fields_names: '',
  };

  if (currentFeedSettings?.feed_selected === true && currentFeedSettings?.ref_spec_name !== '') {
    //if this specific feed was already selected, then use the settings from the previous selection
    dataFeedParams.ref_spec_name = currentFeedSettings.ref_spec_name || '';
    dataFeedParams.primary_keys = currentFeedSettings.primary_keys || '';
    dataFeedParams.ref_field_list_selector = vendorFeedSpecsWrapper.getRefFieldListSelector() || '';
    dataFeedParams.ref_fields_names = vendorFeedSpecsWrapper.getRefFieldsNames() || '';
    dataFeedParams.ref_spec_resource_name = currentFeedSettings.ref_spec_resource_name || '';
  } else if (thisFeedSpecs) {
    //if this feed was not selected, then use the default settings from the vendor feed specs
    dataFeedParams.ref_spec_name = thisFeedSpecs?.default_ref || '';

    if (vendorFeedSpecsWrapper.isV2Template()) {
      // For V2: Use primary_keys array and feed_params
      const v2FeedSpecs = thisFeedSpecs as any;
      dataFeedParams.primary_keys = v2FeedSpecs?.primary_keys?.[0] || '';

      // Get ref_spec_resource_name from feed_params
      const feedParams = v2FeedSpecs?.feed_params || {};
      dataFeedParams.ref_spec_resource_name = feedParams['feed_spec.object_name'] || '';
    } else {
      // For V1: Use primary_key_selectors as before
      dataFeedParams.primary_keys = vendorFeedSpecsWrapper.getPrimaryKey(feedName) || '';
      dataFeedParams.ref_spec_resource_name =
        vendorFeedSpecsWrapper.getRefSpecResourceName(dataFeedParams.ref_spec_name) || '';
    }

    dataFeedParams.ref_field_list_selector = vendorFeedSpecsWrapper.getRefFieldListSelector() || '';
    dataFeedParams.ref_fields_names = vendorFeedSpecsWrapper.getRefFieldsNames() || '';
  }

  return dataFeedParams;
};
